
<div [formGroup]="form()">
  <ci-text-field-outlined 
    type="text"
    [label]="'Nombre' | translate"
    [placeholder]="'Nombre' | translate"
    (input)="handleInput($event)"
  ></ci-text-field-outlined>
</div>